import { render, staticRenderFns } from "./ConsultarSolicitacao.vue?vue&type=template&id=de17d45c&scoped=true"
import script from "./ConsultarSolicitacao.vue?vue&type=script&lang=js"
export * from "./ConsultarSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de17d45c",
  null
  
)

export default component.exports